/**
 * QZ Tray Print Utility
 *
 * Handles communication with QZ Tray for silent local printing
 * Demo certificate hardcoded for workstation-specific QZ Tray installation
 */

import qz from 'qz-tray';

let isConnected = false;
let connectionPromise = null;
let privateKeyCache = null;
let activeStation = localStorage.getItem('qzStation') || 'pack';

// Listen for websocket close to reset connection state
qz.websocket.setClosedCallbacks(() => {
  console.log('QZ Tray: websocket closed');
  isConnected = false;
  connectionPromise = null;
  privateKeyCache = null;
});

// Pack station certificate (generated Feb 2 via Site Manager on packing machine)
const PACK_CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIECzCCAvOgAwIBAgIGAZwkSBOHMA0GCSqGSIb3DQEBCwUAMIGiMQswCQYDVQQG
EwJVUzELMAkGA1UECAwCTlkxEjAQBgNVBAcMCUNhbmFzdG90YTEbMBkGA1UECgwS
UVogSW5kdXN0cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMx
HDAaBgkqhkiG9w0BCQEWDXN1cHBvcnRAcXouaW8xGjAYBgNVBAMMEVFaIFRyYXkg
RGVtbyBDZXJ0MB4XDTI2MDIwMjE2MTM0OVoXDTQ2MDIwMjE2MTM0OVowgaIxCzAJ
BgNVBAYTAlVTMQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYD
VQQKDBJRWiBJbmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMs
IExMQzEcMBoGCSqGSIb3DQEJARYNc3VwcG9ydEBxei5pbzEaMBgGA1UEAwwRUVog
VHJheSBEZW1vIENlcnQwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDG
Xuwt89ht3/5xLoxjeNA1Gg0DgZeTE++JNlHqofCZB3K+CgSNVDZCdznSu4U7bhf1
eqoLIN1jSRQVWecQNP8wxRtYIbtazccQdrHPBGoLtnbp38M35J7BltYpKYx7eodn
HvgY5gQ5SazlXkp09HQk44VEFuChbrspOCsG+JVHm0wjEjyGKDGLre40zA+0No4o
3VFL0waxKTPj9Y8wt382GpgCeuy6np7/W3zSD3GreOm2LDopcflMbmR51S5q/F5u
/Y/l+rI1j2IJ53CIGwIKeZtjeznnF8qloGXngz6oVXL50NR4eJv0OnJyLW5VR/ST
H1nM/5QmFZTD7Q0Sz2RvAgMBAAGjRTBDMBIGA1UdEwEB/wQIMAYBAf8CAQEwDgYD
VR0PAQH/BAQDAgEGMB0GA1UdDgQWBBQipZvEYXv9eZr0/VAQFPAtgINYTjANBgkq
hkiG9w0BAQsFAAOCAQEAlTQu9aCDBWQOfYM7+H5EiIvpq0FQuZ8FOoRPXGKVHjiC
dtQi8bSFjoQW4fqI028mOUb8gCQrhyb2d0LIHC6mZu002d/LjHpBpYBT4bOsmSlb
K/Cbu5qiuX38Nyj+fH8Q1t2Mqt/BOaALrvDk38FUq4OFY2iqTEvUJpcd8nEL5A4u
865w/UHFx8AmHL1SKB+SGWqdvU3LGqr5l63jrt6mTYak2looidj5Z62Iy6jMXwUE
Aj2K7RHWS9ixzkB7kova/y/Kdu84i0ri3sq2K9lm2ZKri47TynFuj9sjyGXFMFeW
0J6R9btHE+hogdSi4D2hDALA3WTygXh+ZFWKeXtBOw==
-----END CERTIFICATE-----`;

const PACK_PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDGXuwt89ht3/5x
LoxjeNA1Gg0DgZeTE++JNlHqofCZB3K+CgSNVDZCdznSu4U7bhf1eqoLIN1jSRQV
WecQNP8wxRtYIbtazccQdrHPBGoLtnbp38M35J7BltYpKYx7eodnHvgY5gQ5Sazl
Xkp09HQk44VEFuChbrspOCsG+JVHm0wjEjyGKDGLre40zA+0No4o3VFL0waxKTPj
9Y8wt382GpgCeuy6np7/W3zSD3GreOm2LDopcflMbmR51S5q/F5u/Y/l+rI1j2IJ
53CIGwIKeZtjeznnF8qloGXngz6oVXL50NR4eJv0OnJyLW5VR/STH1nM/5QmFZTD
7Q0Sz2RvAgMBAAECggEAKItwNHg5jUOSCuobsZ0Y2TGo5UWQiHQzqlTa610MAwsd
ra/4fDZxHKanv+Wp9pqq9PaMWNfvyAJAw5hrfMmIOxyeWSYT2BxlCn1oHErnrdsu
dODSUtM8i47b2O/wEbDaif4vcU9aH6dqWjsqdrscHgoOy/rtELHEOUmMqdEXGdpM
tKX9TKH715R1y6JAoFWi6ZkWwxE3Iujv8x9EdxcbwI/Dh2DCVK8IHoYOzlIG+qZj
OTdEWIm/oQ/vVnrvEKhN4eHCGtPYs7mcIfO+8VHmHCvFpc4dcNSlQyTNI108tTKk
mbock7xzh6Gn5zFQfGyxtH8jY0cG0CeX2+81BUBFiQKBgQDuBC/lKV+4WLz2CKZu
sVlCaH9W6OMZOXhhmbhcakBrvKHld7nYMeoDWPWL1SbreeM9TrC2Z+kmfUdcz6vz
3SR0A1utYBrszMIrCnLqkTuFjh/F531iwAvRf5z/bQ26RwUVpq/ZEeOWQMMTTh7n
yiHAa/sr2kBzmJrwtrZlfVo8+wKBgQDVW+TsHYSs7GAdiKpVwe/xsWv64WFLNSSG
m10afyYVhpderXSU/mgvOB7veItjOcHmb0VIyALxhnDtSGGAgqf0URL375TTC006
I/rSlN8nNVqBnI/xqU9SHfdQ/mX/QmxAkuQCm9OWrhyLBiSWJMPQjwQS/i/ACRqz
RgMN3EK0HQKBgEF/z3pdx2Sgrud5++sMTQb0YM6W6h//67vYJJ7x8mZzk43lQ7RW
EBL5wSDI+Jvmf/1YEVMxBz07To8g6y4B1k1Cu1Db2Kz/sBNOHc+lRd77/Ixmpt+s
/9OYLakw5o0zjBeoNk4jGSE5EzXV0rVwr5cXYBhySDhHb6P8c/c75sBPAoGBAKRh
FFJFu75uru6SKInBzVds1kCH/CmxW97JPEX5yCG1fFHZWYShLSuUFWFyghGEojsj
Z0HXt0zVw5NMvLIB99xnyjFzSDoA7xLoPYqYYAUZOg25zbzmMNKXe7/PAE5Voolt
onXQEIh6xEroBLAYyzSXuw/W/nr5iLSuMBQxqsKRAoGBAOyrJ7dqYCvNicBBW8BQ
llKgwor653Uwx8+4KhecdG+DnQhr8bb3S9ZUi53f1QJYOEwyKBiEOCZ9Wbdgm+aq
+t7cEY4Oyh7uL5yJ7GfMONoVKk3Kjz40+lpgBC3nVFyswQxciKpmwE7/IIFZfm4B
+oMJpHOp5jV+PYam4mV/b1h3
-----END PRIVATE KEY-----`;

// Pick ticket station certificate (generated Mar 18 via Site Manager on pick ticket machine)
const PICK_CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIECzCCAvOgAwIBAgIGAZ0H3Dm7MA0GCSqGSIb3DQEBCwUAMIGiMQswCQYDVQQG
EwJVUzELMAkGA1UECAwCTlkxEjAQBgNVBAcMCUNhbmFzdG90YTEbMBkGA1UECgwS
UVogSW5kdXN0cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMx
HDAaBgkqhkiG9w0BCQEWDXN1cHBvcnRAcXouaW8xGjAYBgNVBAMMEVFaIFRyYXkg
RGVtbyBDZXJ0MB4XDTI2MDMxODIwNDkyNloXDTQ2MDMxODIwNDkyNlowgaIxCzAJ
BgNVBAYTAlVTMQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYD
VQQKDBJRWiBJbmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMs
IExMQzEcMBoGCSqGSIb3DQEJARYNc3VwcG9ydEBxei5pbzEaMBgGA1UEAwwRUVog
VHJheSBEZW1vIENlcnQwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCi
GBKK4C0bJV/UWHBVxkzyh+s/66a0/Cf3eRy0A8MX8KWM/jZld8+5ttWeKT4CG98Y
QAb4UyUxNZZGUt9ttYh/pa90LFUgMEN/Oy7cvx4S0EoM94nN6rWqrgDg8fwS7C50
W41+2j0rBudCS0J3efr8jb9WdqefyNlsoZT1E99eiFtj7tlKLNP1JEqFYi9CrQfs
57tDrNw7qv2umEcccVZVi1oLu+DPPrLKg1TJfBQK7ZRiJyFYvRYpm+6XmI5uv5nv
Sg1E05nzWZxXGqWwa1qUIsFH1gkBISe5Qexw6l87Acd75hu57Gp+2ZfdIoL6iGyl
BN2g63P5r1bpAuB9F7qpAgMBAAGjRTBDMBIGA1UdEwEB/wQIMAYBAf8CAQEwDgYD
VR0PAQH/BAQDAgEGMB0GA1UdDgQWBBQWnvjxJaXl+Osim2C9w/kFGA/w2DANBgkq
hkiG9w0BAQsFAAOCAQEAFTydjW3e+OWfHH1a6fabs+EW5tVzUHsnY/CTO4ODs+h9
ZPhSiJCHUCGt1UlbwXbh50s99IVlpTEpfl0bz2Z3PV/84nHLvNGHH0/7nyA/jUlm
EIsaYMHvuf04niYwgD9lOioUBDGKPAkltWopFuiBP+7Hq//Xr9yEKyaj0VVEDRnU
VcpLrPFJA+56QDISVLWCL3NWLV3FH/AOn3mgnOaNqPBldza7/PHK9z7e64elnh74
tmULn34g6HiqiEnZobU+ytCFO1boajOMGpMaKdjDgfqGS8rYPLXQC46DYnggLJAH
3k2n0c6gaKDFXrXwtIWuhB9HNegqlDqFeQtCEIUZ1w==
-----END CERTIFICATE-----`;

const PICK_PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCiGBKK4C0bJV/U
WHBVxkzyh+s/66a0/Cf3eRy0A8MX8KWM/jZld8+5ttWeKT4CG98YQAb4UyUxNZZG
Ut9ttYh/pa90LFUgMEN/Oy7cvx4S0EoM94nN6rWqrgDg8fwS7C50W41+2j0rBudC
S0J3efr8jb9WdqefyNlsoZT1E99eiFtj7tlKLNP1JEqFYi9CrQfs57tDrNw7qv2u
mEcccVZVi1oLu+DPPrLKg1TJfBQK7ZRiJyFYvRYpm+6XmI5uv5nvSg1E05nzWZxX
GqWwa1qUIsFH1gkBISe5Qexw6l87Acd75hu57Gp+2ZfdIoL6iGylBN2g63P5r1bp
AuB9F7qpAgMBAAECggEALfgZuhzdbedph/UU1p6IT/fP9a7E9mrUgtBsHXk7qNxs
dtHZZ2lVFdwONO6JUVvKJzxxPZeG4q/J0GPMTXbAIUNBwPaZpalKWxjTr3Lb+oXr
mkXRZP59SsxSH3lA/bTRb9pPBHysADnS9/AUB4Imdd1VOBYqb5wsXSxt7BsYq9wY
QB+Q+GCJC3ydI3cERUaoLpWiJ1s/ZLHfkVZiZcQiTIz0QczJr1GtP9EedkwFm3Am
2gse8Wita1O6BwwHESuEUE+gm0aq35oM7q8EtciW1xNeXnHC5aQJmgOeivdlLZ7N
s1Yq0QdyeYk4UKRNhsAAUrEyD+9lKZohQUyJiUV7iQKBgQDTXOtP8EEIDnaB46T2
fKGvtqcwNxe6WmNcL6JvLgvOla2eqzmnAsn6zoevCVR8BYdsct506q5RYUHDqO/X
N4Y24EWEtgvVKMUkl5apL+ROH/tcv9OpUw1BiJqWD/pzGcYAToNlRQu/fRMFNvuI
grnmA3tzoSxSt0hqX4gczrJlzwKBgQDEU30PwcE+Tlhgo3HpBOw5Jg6Bq1kDW6gL
PAw+S82hvrgsZPwMZhH67pb8ELmK3Fs+Pt6L6psOqk89fRtlFGxpiOOhAfB7ZpjQ
HFoKJ5X/l/aA2lHbkeI2tgW8ROwQUDrg2YhQJ+DeHyxV9qpZxKvNFpfdvQ+xC1EK
E3DdAAhuBwKBgAW5e4oTuL8uHRmRf9NJNtvad5a/tz3N2ukRRTX7qkgzF5u3iX0z
fyLy2wvrlcUyJSPTzKCgBo6fsrdI6Q4MK+9qjZd1ksZ4Lza5gFQevvE6voUZkPMC
E9bVi1JLJn5dkVZKyhZBE3thONWoUpG08LIBICPWlqu62RRAeCBHnN9TAoGBAIUH
KUue9wj33yyEM3A4NLQ4lEXKzALZfVE3e/hONuStLXBvcNYZ538HYekkkASGcZEI
2pUl/7D9N7orZn+kSh1scwkrHj8PcuY4/823qwzIdHA0/phwDj8SMWqzrN0U8ABh
hdsCWn1H1Cvfeuheuia6c2b9b3+AcoYITEaDejLLAoGBALw5DfF2uuvsffpKxCxr
csvIDaEWWOjmeKRLlBPIapycB4WDUglYdj7ebaRp2J7bH6/nQ3NAD3nuvJFBx5Fz
HPhsrz5ozmQ9oAwQqgUXMYoSVNxPMvdcavJk7y2wD5YYiMoo6cue1YBcOhNVLVMh
fibiC8KFtQrKhBcOe1cxdlGx
-----END PRIVATE KEY-----`;

// Station-specific cert/key selection
const CERTS = {
  pack: { cert: PACK_CERTIFICATE, key: PACK_PRIVATE_KEY },
  pick: { cert: PICK_CERTIFICATE, key: PICK_PRIVATE_KEY },
};

function getActiveCert() { return CERTS[activeStation]?.cert || PACK_CERTIFICATE; }
function getActiveKey() { return CERTS[activeStation]?.key || PACK_PRIVATE_KEY; }

// Convert PEM private key to CryptoKey for Web Crypto API
async function importPrivateKey() {
  if (privateKeyCache) return privateKeyCache;

  const pemKey = getActiveKey();
  // Remove PEM header/footer and decode base64
  const pemContents = pemKey
    .replace('-----BEGIN PRIVATE KEY-----', '')
    .replace('-----END PRIVATE KEY-----', '')
    .replace(/\s/g, '');

  const binaryDer = Uint8Array.from(atob(pemContents), c => c.charCodeAt(0));

  const key = await window.crypto.subtle.importKey(
    'pkcs8',
    binaryDer.buffer,
    {
      name: 'RSASSA-PKCS1-v1_5',
      hash: 'SHA-512'
    },
    false,
    ['sign']
  );

  privateKeyCache = key;
  return key;
}

// Sign data using Web Crypto API
async function signData(data, privateKey) {
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);

  const signature = await window.crypto.subtle.sign(
    'RSASSA-PKCS1-v1_5',
    privateKey,
    dataBuffer
  );

  // Convert ArrayBuffer to base64
  const signatureArray = new Uint8Array(signature);
  let binary = '';
  for (let i = 0; i < signatureArray.length; i++) {
    binary += String.fromCharCode(signatureArray[i]);
  }
  return btoa(binary);
}

// Configure certificate - dynamically returns cert for the active station
qz.security.setCertificatePromise((resolve, reject) => {
  console.log('QZ Tray: Using', activeStation, 'station certificate');
  resolve(getActiveCert());
});

// Configure signature using native Web Crypto API
qz.security.setSignatureAlgorithm("SHA512");
qz.security.setSignaturePromise((toSign) => {
  return async (resolve, reject) => {
    try {
      const privateKey = await importPrivateKey();
      const signature = await signData(toSign, privateKey);
      console.log('QZ Tray: Request signed successfully');
      resolve(signature);
    } catch (err) {
      console.error('QZ Tray: Signing failed:', err);
      reject(err);
    }
  };
});

/**
 * Set which station's certificate to use ('pack' or 'pick')
 * Call before connect() — disconnects if switching stations
 */
export async function setStation(station) {
  if (station === activeStation) return;
  activeStation = station;
  localStorage.setItem('qzStation', station);
  privateKeyCache = null;
  // Disconnect so next connect() uses the new cert
  if (qz.websocket.isActive()) {
    await qz.websocket.disconnect();
    isConnected = false;
    connectionPromise = null;
  }
  console.log('QZ Tray: Switched to', station, 'station certificate');
}

/**
 * Connect to QZ Tray
 */
export async function connect() {
  if (isConnected && qz.websocket.isActive()) {
    return true;
  }

  // Reset stale state if connection dropped
  if (!qz.websocket.isActive()) {
    isConnected = false;
    connectionPromise = null;
  }

  if (connectionPromise) {
    return connectionPromise;
  }

  connectionPromise = qz.websocket.connect()
    .then(() => {
      isConnected = true;
      console.log('QZ Tray connected (signed)');
      return true;
    })
    .catch((err) => {
      isConnected = false;
      connectionPromise = null;
      console.error('QZ Tray connection failed:', err);
      throw err;
    });

  return connectionPromise;
}

/**
 * Disconnect from QZ Tray
 */
export async function disconnect() {
  if (qz.websocket.isActive()) {
    await qz.websocket.disconnect();
    isConnected = false;
    connectionPromise = null;
  }
}

/**
 * Get list of available printers
 */
export async function getPrinters() {
  await connect();
  return qz.printers.find();
}

/**
 * Find a specific printer by name (partial match)
 */
export async function findPrinter(searchTerm) {
  await connect();
  const printers = await qz.printers.find();

  // Try exact match first
  let printer = printers.find(p => p.toLowerCase() === searchTerm.toLowerCase());

  // Try partial match
  if (!printer) {
    printer = printers.find(p => p.toLowerCase().includes(searchTerm.toLowerCase()));
  }

  // Try to find any Zebra printer
  if (!printer) {
    printer = printers.find(p => p.toLowerCase().includes('zebra'));
  }

  return printer;
}


/**
 * Print raw base64 bytes (e.g. ESC/POS for receipt/label printers with
 * cutters) to a printer found by name search.
 */
export async function printRawBase64(base64Data, printerSearch = 'volcora') {
  await connect();
  let printer = await findPrinter(printerSearch);
  if (!printer) printer = await findPrinter('pos');
  if (!printer) printer = await findPrinter('receipt');
  if (!printer) throw new Error('No label/receipt printer found via QZ Tray');
  const config = qz.configs.create(printer, { raw: true });
  await qz.print(config, [{ type: 'raw', format: 'base64', data: base64Data }]);
  return { success: true, printer };
}

/**
 * Print ZPL data to a Zebra printer
 */
export async function printZPL(zplData, printerName = null) {
  await connect();

  // Find printer
  let printer = printerName;
  if (!printer) {
    printer = await findPrinter('zebra');
  }

  if (!printer) {
    throw new Error('No Zebra printer found. Please check printer connection.');
  }

  // Configure for RAW ZPL printing
  const config = qz.configs.create(printer, {
    raw: true
  });

  // Send ZPL data
  const data = [{
    type: 'raw',
    format: 'plain',
    data: zplData
  }];

  await qz.print(config, data);

  return {
    success: true,
    printer: printer
  };
}

/**
 * Print a test label
 */
export async function printTestLabel(printerName = null) {
  const testZPL = `^XA
^FO50,50^ADN,36,20^FDQZ Tray Test^FS
^FO50,100^ADN,24,12^FDPrinter: ${printerName || 'Auto-detected'}^FS
^FO50,140^ADN,24,12^FDTime: ${new Date().toLocaleString()}^FS
^FO50,180^ADN,24,12^FDMode: Production (Signed)^FS
^FO50,240^BY3^BCN,100,Y,N,N^FD123456789^FS
^XZ`;

  return printZPL(testZPL, printerName);
}

/**
 * Print HTML content to a system printer (pixel mode)
 * Used for packing slips on laser printers
 */
export async function printHTML(htmlContent, printerName) {
  await connect();

  if (!printerName) {
    throw new Error('Printer name is required for HTML printing');
  }

  const config = qz.configs.create(printerName, {
    margins: { top: 0, right: 0, bottom: 0, left: 0 },
    units: 'in',
    scaleContent: true
  });

  const data = [{
    type: 'pixel',
    format: 'html',
    flavor: 'plain',
    data: htmlContent
  }];

  await qz.print(config, data);

  return {
    success: true,
    printer: printerName
  };
}

/**
 * Print a PDF (base64-encoded) to a system printer (pixel mode)
 * Used for FNSKU labels on laser printers
 */
export async function printPdf(base64PdfData, printerName) {
  await connect();

  if (!printerName) {
    throw new Error('Printer name is required for PDF printing');
  }

  const config = qz.configs.create(printerName, {
    margins: { top: 0.25, right: 0.25, bottom: 0.25, left: 0.25 },
    units: 'in',
    scaleContent: true
  });

  const data = [{
    type: 'pixel',
    format: 'pdf',
    data: `data:application/pdf;base64,${base64PdfData}`
  }];

  await qz.print(config, data);

  return {
    success: true,
    printer: printerName
  };
}

/**
 * Check if QZ Tray is available
 */
export async function isAvailable() {
  try {
    await connect();
    return true;
  } catch (err) {
    return false;
  }
}

/**
 * Get QZ Tray version info
 */
export async function getVersion() {
  await connect();
  return qz.api.getVersion();
}

/**
 * Check if running in production mode (with certificates)
 */
export function isProductionMode() {
  return true; // Always production mode with hardcoded certs
}

export default {
  setStation,
  connect,
  disconnect,
  getPrinters,
  findPrinter,
  printZPL,
  printHTML,
  printPdf,
  printTestLabel,
  isAvailable,
  getVersion,
  isProductionMode
};
